import { render, staticRenderFns } from "./ExtratoGlosas.vue?vue&type=template&id=0b4da75f"
import script from "./ExtratoGlosas.vue?vue&type=script&lang=js"
export * from "./ExtratoGlosas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports